<script setup>
import VideoCall from "@/components/VideoCall/VideoCall.vue";

const props = defineProps({
  rtcId: {
    type: String,
    required: true,
  },
});


const urlParams = new URLSearchParams(window.location.search);

let role = "";
let name = "";

const agent = urlParams.get("agent");
const user = urlParams.get("user");

if (agent) {
  role = "agent";
  name = agent;
} else if (user) {
  role = "user";
  name = user;
} else {
  role = "user";
  name = "user";
}
</script>

<template>
  <VideoCall :rtc-id="props.rtcId" :role="role" :name="name"></VideoCall>
</template>
